<template>
  <div class="docks-wrapper">
    <div class="gate-list">
      <RadioGroup v-if="gateWithDocks.length" v-model="currentGate">
        <Radio
          v-for="gate in gateWithDocks"
          :label="gate.gate_id"
          v-bind:key="gate.gate_id">
          {{$depot.gate(gate.gate_id).name}}
        </Radio>
      </RadioGroup>
    </div>

    <div class="docks">
      <div v-if="selectedDocksInGate.length > 0">
        <p>{{$t('INDENT_SELECTED_DOCKS')}}</p>
        <CheckboxGroup v-model="selectedDocks">
          <Checkbox
            v-for="dock in selectedDocksInGate"
            :label="dock.id"
            :checked="true"
            :disabled="(dock.loading_started_at !== null || !$hasPermission('indent_add_docks'))"
            :key="dock.id">
            {{$depot.dock(dock.id).name}}
          </Checkbox>
        </CheckboxGroup>
      </div>
      <div v-if="leftDocks.length > 0 && !currentGateDetail.dispatched_at">
        <p>{{$t('INDENT_SELECT_DOCKS')}}</p>
        <CheckboxGroup v-model="selectedLeftDocks">
          <Checkbox
            v-for="dock in leftDocks"
            :label="dock.id"
            :disabled="(!$hasPermission('indent_add_docks'))"
            :key="dock.id">
            {{dock.name}}
          </Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="submit-button" v-if="$hasPermission('indent_add_docks')">
      <Spinner v-if="showSpinner" />
      <button v-else class="btn btn-primary" @click="addDocks">
        {{$t('INDENT_SUBMIT')}}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['order'],

  data() {
    return {
      currentGate: null,
      selectedDocks: [],
      selectedLeftDocks: [],
      showSpinner: false,
    };
  },

  created() {
    this.currentGate = this.getCurrentGate();
  },

  computed: {

    gateWithDocks() {
      return this.order.sources.filter(gate => this.$depot.gateHasDocks(gate.gate_id));
    },

    selectedDocksInGate() {
      const currentGate = this.currentGate;
      this.selectedDocks = [];
      return this.order.docks.filter(dock => dock.gate_id === currentGate);
    },

    currentGateDetail() {
      const currentGate = this.currentGate;
      return this.order.sources.find(gate => gate.gate_id === currentGate);
    },

    leftDocks() {
      const currentGate = this.currentGate;
      const orderDocksIds = this.order.docks.filter(dock =>
        dock.gate_id === currentGate).map(dock => dock.id);
      return this.$depot.docksByGate(currentGate).filter(dock =>
        orderDocksIds.indexOf(dock.id) === -1);
    },
  },

  methods: {
    getCurrentGate() {
      const orderGates = this.order.sources;
      const currentTruckedInGate = orderGates.find(gate =>
        gate.arrived_at !== null && gate.dispatched_at === null);
      return (currentTruckedInGate && currentTruckedInGate.gate_id) || this.order.sources[0].gate_id;
    },

    async addDocks() {
      this.showSpinner = true;
      const data = [];
      const orderId = this.order.order_number;
      const gateId = this.currentGate;
      const updatedSelectedDock = this.selectedDocks;
      const updatedDock = this.selectedLeftDocks;
      const dockIds = [].concat(updatedSelectedDock, updatedDock);
      const payload = {
        gate_id: gateId,
        dock_ids: dockIds,
      };
      data.push(payload);
      try {
        const result = await this.$store.dispatch('order/addDocks', { orderId, data });
        this.showSpinner = false;
        if (result && result.error) {
          this.$error({ message: result.error });
        } else if (result.order_number) {
          this.selectedLeftDocks = [];
          this.$emit('done', 'addDocks');
          this.$success({ message: this.$t('INDENT_DOCK_ASSIGNED_SUCCESS_MSG', { order_number: result.order_number }) });
        }
      } catch (error) {
        // log
      }
    },
  },

  watch: {
    currentGate() {
      this.selectedLeftDocks = [];
    },
  },

};
</script>

<style lang="scss" scoped>
.docks {
  margin-bottom: 20px;
  .el-checkbox {
    width: 150px;
    margin: 5px;
  }
  .gate-list {
    margin-top: 15px;
  }
}
</style>
